import React, { FC, HTMLProps, ReactNode, useEffect, useState } from "react";
import cn from "classnames";
import { nanoid } from "nanoid";
import { useHtmlStates } from "../../hooks";
import stl from "./Radio.module.scss";

type Value = string | number;
interface Props extends Omit<HTMLProps<HTMLDivElement>, "value" | "onSelect"> {
  value: Value;
  onSelect?: (v: Value) => void;
  selected?: boolean;
  children: ReactNode;
}
const Radio: FC<Props> = (componentProps) => {
  const [{ isActive, isFocused, isHovered }, wrapRef] = useHtmlStates();

  const { value, selected, onSelect, children, ...props } = componentProps;

  const [id, setId] = useState<string>(nanoid());

  useEffect(() => {
    if (props.id) setId(props.id);
  }, [props.id]);

  return (
    <div
      {...props}
      ref={wrapRef}
      tabIndex={0}
      onClick={() => onSelect?.(value)}
      onKeyDown={({ key }) => {
        if (key === "Enter" || key === " ") {
          onSelect?.(value);
        }
      }}
      className={cn(props?.className, stl.block, {
        [stl.selected]: selected,
        [stl.active]: isActive,
        [stl.focus]: isFocused,
        [stl.hover]: isHovered,
      })}
    >
      <label htmlFor={id} className={stl.input}>
        <input type="radio" value={value} />
      </label>
      <label className={stl.label}>{children}</label>
    </div>
  );
};

export default Radio;
